import styled from 'styled-components'
import { Pagination as OPagination } from '@chegg-ui/pagination'
import { spacing } from '@chegg-ui/theme'

export const Pagination = styled(OPagination)`
  padding: ${spacing.px16};
  text-align: center;
`
